module.exports = 
{
  'productUrlPrefix': 'products',
  'collectionUrlPrefix': 'collection'
} 